import { addIcon, Icon } from '@iconify/react/offline';
import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material/styles';
import { BUNDLED_ICONS } from './icon-bundle.gen.js';

/**
 * Every icon is registered from the generated bundle. The offline entry point
 * of `@iconify/react` carries no API client at all, so no screen — least of all
 * the public portal — can reach `api.iconify.design` for an icon at runtime.
 * `pnpm --filter @btsis/ui icons` regenerates the bundle; `icon-bundle.test.ts`
 * fails if a source file names an icon the bundle does not carry.
 */
for (const [name, data] of Object.entries(BUNDLED_ICONS)) addIcon(name, data);

const UNKNOWN_ICON = 'solar:question-square-bold-duotone';

export type IconifyProps = {
  icon: string;
  width?: number | string;
  sx?: SxProps<Theme>;
  className?: string;
};

export function Iconify({ icon, width = 20, sx, className }: IconifyProps) {
  const name = icon in BUNDLED_ICONS ? icon : UNKNOWN_ICON;

  return (
    <Box
      className={className}
      sx={[
        { width, height: width, flexShrink: 0, display: 'inline-flex' },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Icon icon={name} width="100%" height="100%" />
    </Box>
  );
}
